import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#00BD73",
        themeGrey: "#EFEFEF",
        secondary: "#1F5D51",
        secondary2: "#FFB443",
        secondary2light: "#FFF7EC",
        btnText: "#6A7784",
        gray: "#787878",
        green2: '#E5F8F1',
        red: '#F03737',
        red2: '#FDEBEB',
        black: '#1E1E1E',
        black2: '#E8E8E8',
        gray2: '#e0e0e0',
      },
    },
  },
  iconfont: 'md'
});
